import gql from "graphql-tag";

export default {
    update: gql`
    mutation UpdateAgenda2Cell ($input: UpdateAgenda2CellInput!) {
        updateAgenda2Cell (input: $input) {
            id
            cell_type
            background_color
            text_color
            background_color_filter_category
            background_color_filter_category_checked
            background_color_filter_day
            background_color_filter_day_checked
            background_color_pop_up
            background_color_button_open
            text_color_day_filter
            text_color_day_filter_selected
            text_color_category_filter
            text_color_category_filter_selected
            text_color_time
            text_color_event_name
            text_color_event_details
            text_color_description
            text_color_button_open
            color_button_close
            border_color_selected_day
            border_color_selected_category
            font_size_name
            font_size_time
            font_size_details
            font_size_popup
            font_size_filter_day
            font_size_filter_category
            list_max_height_vh
            bolder_radius_filter_day
            bolder_radius_filter_category
            hide_past_events
            show_all_tab
            show_end_time
            subtitle_new_line
            layout
            color_timeline
            background_color_event
            text_color_card
            text_color_card_details
            background_image_uri
            color_theme
            background_fit
            days {
                id
                cell_id
                date
                text
                i18n {
                    language_code
                    text
                }
            }
            categories {
                id
                cell_id
                name
                i18n {
                    language_code
                    name
                }
            }
            events {
                id
                cell_id
                name
                agenda_day_id
                start
                end
                description
                image_uri
                speaker
                location
                language
                category_id
                subtitle
                popup
                title_bold
                title_italic
                title_font_family
                title_color
                title_font_size
                i18n {
                    language_code
                    name
                    description
                    image_uri
                    speaker
                    location
                    language
                }
            }
            i18n {
                language_code
                text
            }
        }
    }`,

    get: gql`
    query Agenda2Cell($id: ID!) {
        agenda2Cell(id: $id) {
            id
            cell_type
            background_color
            text_color
            background_color_filter_category
            background_color_filter_category_checked
            background_color_filter_day
            background_color_filter_day_checked
            background_color_pop_up
            background_color_button_open
            text_color_day_filter
            text_color_day_filter_selected
            text_color_category_filter
            text_color_category_filter_selected
            text_color_time
            text_color_event_name
            text_color_event_details
            text_color_description
            text_color_button_open
            color_button_close
            border_color_selected_day
            border_color_selected_category
            font_size_name
            font_size_time
            font_size_details
            font_size_popup
            font_size_filter_day
            font_size_filter_category
            list_max_height_vh
            bolder_radius_filter_day
            bolder_radius_filter_category
            hide_past_events
            show_all_tab
            show_end_time
            subtitle_new_line
            layout
            color_timeline
            background_color_event
            text_color_card
            text_color_card_details
            background_image_uri
            color_theme
            background_fit
            days {
                id
                cell_id
                date
                text
                i18n {
                    language_code
                    text
                }
            }
            categories {
                id
                cell_id
                name
                i18n {
                    language_code
                    name
                }
            }
            events {
                id
                cell_id
                name
                agenda_day_id
                start
                end
                description
                image_uri
                speaker
                location
                language
                category_id
                subtitle
                popup
                title_bold
                title_italic
                title_font_family
                title_color
                title_font_size
                i18n {
                    language_code
                    name
                    description
                    image_uri
                    speaker
                    location
                    language
                }
            }
            i18n {
                language_code
                text
            }
        }
    }`,

    addEvent: gql`
    mutation AddAgendaEvent($input: AddAgendaEventInput!) {
        addAgendaEvent(input: $input) {
            id
        }
    }`,

    updateEvent: gql`
    mutation UpdateAgendaEvent($input: UpdateAgendaEventInput!) {
        updateAgendaEvent(input: $input) {
            id
        }
    }`,

    deleteEvent: gql`
    mutation DeleteAgendaEvent($id: ID!) {
        deleteAgendaEvent(id: $id)
    }`,

    addDay: gql`
    mutation AddAgendaDay($input: AddAgendaDayInput!) {
        addAgendaDay(input: $input) {
            id
        }
    }`,

    updateDayDate: gql`
    mutation UpdateAgendaDayDate($id: ID!, $date: String!) {
        updateAgendaDayDate(id: $id, date: $date) {
            id
        }
    }`,

    deleteDay: gql`
    mutation DeleteAgendaDay($id: ID!) {
        deleteAgendaDay(id: $id)
    }`,
};
